<script setup lang="ts">
import { toasts } from '../model/state'
import ToastElement from './ToastElement.vue'
import { useToast } from '@/shared/toasts'

const { closeToast, pauseToast, resumeToast } = useToast()
</script>

<template>
  <div class="fixed top-6 right-6 z-99999 flex flex-col gap-3 pointer-events-none">
    <TransitionGroup name="toast" tag="div" class="flex flex-col gap-3">
      <ToastElement
        v-for="toast in toasts"
        :key="toast.id"
        v-bind="toast"
        @close="closeToast"
        @pause="pauseToast"
        @resume="resumeToast"
        class="pointer-events-auto"
        :variant="toast.variant"
        :title="toast.title"
        :message="toast.message"
      />
    </TransitionGroup>
  </div>
</template>
<style>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.toast-move {
  transition: transform 0.3s ease;
}
</style>
